var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 940.74 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".f{fill:#fff;}.g{fill:url(#d);}.h{fill:url(#e);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0,
    y1: 100,
    x2: 200,
    y2: 100,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3489a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#af4498"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#8a4097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6b3c96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#543a95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#433895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#393795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 45.39,
    y1: 100,
    x2: 153.73,
    y2: 100,
    xlinkHref: "#d"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M111.65,9.09c-3.04-12.12-20.25-12.12-23.3,0l-.89,3.57c-1.61,6.43-8.12,10.34-14.55,8.73-2.18-.54-4.16-1.69-5.72-3.31l-2.56-2.64c-8.69-8.99-23.6-.37-20.16,11.64l1,3.55c1.82,6.37-1.87,13.01-8.24,14.83-2.15,.61-4.43,.62-6.58,0l-3.55-1.01c-12-3.44-20.62,11.47-11.64,20.16l2.64,2.56c4.77,4.6,4.9,12.2,.3,16.97-1.56,1.62-3.54,2.76-5.72,3.31l-3.57,.89c-12.12,3.04-12.12,20.25,0,23.3l3.57,.89c6.43,1.61,10.34,8.12,8.73,14.55-.54,2.18-1.69,4.16-3.31,5.72l-2.64,2.56c-8.99,8.69-.37,23.6,11.64,20.16l3.55-1c6.37-1.82,13.01,1.87,14.84,8.24,.62,2.16,.62,4.44,0,6.6l-1.01,3.54c-3.44,12,11.47,20.62,20.16,11.64l2.56-2.64c4.6-4.77,12.2-4.9,16.97-.3,1.62,1.56,2.76,3.54,3.31,5.72l.89,3.57c3.04,12.12,20.25,12.12,23.3,0l.89-3.57c1.61-6.43,8.12-10.34,14.55-8.73,2.18,.54,4.16,1.69,5.72,3.31l2.56,2.64c8.69,8.99,23.6,.37,20.16-11.64l-1-3.55c-1.82-6.37,1.87-13.01,8.24-14.84,2.16-.62,4.44-.62,6.6,0l3.54,1.01c12,3.44,20.62-11.47,11.64-20.16l-2.64-2.56c-4.77-4.6-4.9-12.2-.3-16.97,1.56-1.62,3.54-2.76,5.72-3.31l3.57-.89c12.12-3.04,12.12-20.25,0-23.3l-3.57-.89c-6.43-1.61-10.34-8.12-8.73-14.55,.54-2.18,1.69-4.16,3.31-5.72l2.64-2.56c8.99-8.69,.37-23.6-11.64-20.16l-3.55,1c-6.37,1.82-13.01-1.87-14.83-8.24-.61-2.15-.62-4.43,0-6.58l1.01-3.55c3.44-12-11.47-20.62-20.16-11.64l-2.56,2.64c-4.6,4.77-12.2,4.9-16.97,.3-1.62-1.56-2.76-3.54-3.31-5.72l-.89-3.57Zm-11.65,153.37c-34.5,.49-62.86-27.08-63.35-61.58s27.08-62.86,61.58-63.35c.59,0,1.18,0,1.77,0,34.5,0,62.47,27.97,62.47,62.47s-27.97,62.47-62.47,62.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M80.8,136.36c-.55-.12-1.07-.32-1.56-.6-1.3-.74-2.24-1.94-2.64-3.39s-.21-2.96,.53-4.26l35.09-61.76c1.22-2.16,3.67-3.24,6.09-2.71,.55,.12,1.07,.32,1.56,.6,2.69,1.53,3.64,4.96,2.11,7.65l-35.09,61.76c-1.22,2.16-3.67,3.24-6.09,2.71h0Zm49.04-12.46c-1.5,0-2.91-.58-3.97-1.64-1.06-1.06-1.64-2.47-1.64-3.97s.58-2.91,1.64-3.97l14.31-14.31-14.46-14.46-.02-.03c-2.02-2.2-1.96-5.63,.18-7.76l.21-.21,.05-.03c1.02-.9,2.33-1.4,3.71-1.4,1.5,0,2.91,.58,3.97,1.65l18.28,18.28c2.18,2.19,2.18,5.75-.01,7.94l-18.28,18.28c-1.06,1.06-2.47,1.64-3.97,1.64Zm-60.56,0c-1.5,0-2.91-.58-3.97-1.64l-18.28-18.28c-2.19-2.18-2.19-5.74,0-7.93l18.29-18.29c1.06-1.06,2.47-1.65,3.97-1.65,1.38,0,2.69,.5,3.71,1.4l.05,.03,.21,.21c2.13,2.13,2.19,5.56,.18,7.76l-.03,.03-14.46,14.46,14.31,14.31c1.06,1.06,1.64,2.47,1.64,3.97s-.58,2.91-1.65,3.97c-1.06,1.06-2.47,1.64-3.97,1.64Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M223.86,52.83c0-3.32,1.06-6.04,3.17-8.19s5-3.21,8.64-3.21,6.47,1.07,8.61,3.21,3.21,4.87,3.21,8.19-1.08,6.12-3.25,8.26c-2.16,2.14-5.02,3.21-8.57,3.21s-6.41-1.07-8.57-3.21c-2.16-2.14-3.25-4.9-3.25-8.26Zm22.39,104.21h-21.15V74.25h21.15v82.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M264.99,157.04V45.64h37.19c12.89,0,22.66,2.59,29.32,7.77,6.66,5.18,9.99,12.76,9.99,22.76,0,5.46-1.34,10.27-4.01,14.42-2.67,4.16-6.39,7.2-11.16,9.14,5.45,1.43,9.74,4.31,12.87,8.65s4.7,9.64,4.7,15.91c0,10.71-3.26,18.82-9.77,24.33s-15.8,8.31-27.86,8.42h-41.28Zm21.88-64.73h16.19c11.04-.2,16.56-4.82,16.56-13.85,0-5.05-1.4-8.68-4.19-10.9-2.8-2.22-7.21-3.33-13.24-3.33h-15.31v28.08Zm0,16.22v30.07h18.74c5.15,0,9.18-1.29,12.07-3.86,2.89-2.58,4.34-6.13,4.34-10.67,0-10.2-5.03-15.38-15.1-15.53h-20.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M406.17,148.62c-5.2,6.63-12.4,9.95-21.58,9.95-8.46,0-14.91-2.55-19.36-7.65-4.45-5.1-6.72-12.57-6.82-22.42v-54.24h21.08v53.54c0,8.63,3.74,12.95,11.23,12.95s12.06-2.6,14.73-7.81v-58.67h21.15v82.78h-19.84l-.58-8.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M486.83,94.99c-2.87-.41-5.4-.61-7.58-.61-7.98,0-13.2,2.83-15.68,8.49v54.17h-21.08V74.25h19.91l.58,9.87c4.23-7.6,10.09-11.4,17.58-11.4,2.33,0,4.52,.33,6.56,.99l-.29,21.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M521.19,139.21h38.58v17.83h-65.49v-13.47l37.12-51.49h-36.02v-17.83h63.23v13.03l-37.41,51.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M620.22,148.62c-5.2,6.63-12.4,9.95-21.58,9.95-8.46,0-14.91-2.55-19.36-7.65-4.45-5.1-6.72-12.57-6.82-22.42v-54.24h21.08v53.54c0,8.63,3.74,12.95,11.23,12.95s12.06-2.6,14.73-7.81v-58.67h21.15v82.78h-19.84l-.58-8.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M676.3,74.25l.65,9.26c5.59-7.19,13.15-10.79,22.68-10.79,10.16,0,17.14,4.21,20.93,12.62,5.54-8.42,13.44-12.62,23.7-12.62,8.55,0,14.92,2.61,19.11,7.84,4.18,5.23,6.27,13.1,6.27,23.6v52.87h-21.15v-52.79c0-4.69-.87-8.12-2.62-10.29-1.75-2.17-4.84-3.25-9.26-3.25-6.32,0-10.7,3.16-13.13,9.49l.07,56.85h-21.08v-52.71c0-4.79-.9-8.26-2.7-10.4-1.8-2.14-4.86-3.21-9.19-3.21-5.98,0-10.31,2.6-12.98,7.8v58.53h-21.08V74.25h19.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M809.1,138.6h46.46v18.44h-68.33V45.64h21.88v92.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M892.31,129.42l24.07-83.78h24.36l-36.97,111.4h-22.83l-36.83-111.4h24.28l23.92,83.78Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.d00d25af876e38ac5acb68ecdd9d8ac5.svg";
export { ForwardRef as ReactComponent };